<template>
    <el-dialog title="Edit Directory"
               closeable
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="close"
               width="50%"
    >
        <el-form label-width="100px" size="medium" width="400px">
            <el-form-item label="Name">
                <el-input class="w300" v-model="dir.name"/>
            </el-form-item>
            <el-form-item label="Description">
                <el-input v-model="dir.description"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">Submit</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import ApiService from "../../utils/ApiService";

export default {
    name: "DialogEditDirectory",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        defaultValue: {
            type: Object,
            default: () => {
                return {}
            }
        },
        api: {
            type: String,
            default: '/buildium/associations/dirs'
        }
    },
    data() {
        return {
            visible: false,
            dir: {
                id: 0,
                dir_id: 0,
                name: null,
                description: null,
            }
        }
    },
    watch: {
        defaultValue(val) {
            this.dir = {...val};
        },
        value(val){
            this.visible = val;
        }
    },
    methods: {
        close() {
            this.$emit('input', false);
        },
        submit() {
            let {id, name, description, dir_id} = this.dir;
            if (id) {
                ApiService.put(this.api+'/' + id, {
                    name,
                    description,
                    dir_id
                }).then(response => {
                    this.$message.success('Updated successfully');
                    this.$emit('input', false);
                    this.$emit('saved', response);
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            } else {
                ApiService.post(this.api, {
                    name,
                    description,
                    dir_id
                }).then(response => {
                    this.$message.success('Created successfully');
                    this.$emit('input', false);
                    this.$emit('saved', response);
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            }
        }
    }
}
</script>

<style scoped>

</style>